<template>
  <div class="SectionValue">
    <div class="body">
      <h3>
        {{ $t('title') }}
      </h3>
      <div class="text">
        <ul>
          <li v-for="item in $ta('items')" :key="item">
            {{ item }}
          </li>
        </ul>
      </div>
      <Btn @click="scrollToForm">
        {{ $t('cta') }}
      </Btn>
    </div>
  </div>
</template>

<script>
import { scrollToHash } from '../../../../router/smoothScroll'

export default {
  methods: {
    scrollToForm() {
      scrollToHash('#form')
    },
  },
}
</script>

<style lang="scss">
.SectionValue {
  // background-color: $grey-lighter;
  margin: 2rem 0;
  .body {
    padding: 2rem 0;
    .text {
      margin: 1rem 2rem;
    }
    .Btn {
      margin-top: 1rem;
    }
  }
}
</style>

<i18n>
{
  "en": {
    "cta": "Get your land evaluated",
    "items": [
      "30 years or more of secure revenue",
      "Guaranteed finalization of the project",
      "Low-impact infrastructure: no noise or emissions, limited maintenance activity"
    ],
    "title": "Why cooperate with Sun Investment Group?"
  },
  "it": {
    "cta": "Richiedi una valutazione del tuo terreno",
    "items": [
      "Oltre 30 anni di entrate sicure da un terreno non utilizzato",
      "Garanzia di buon fine del progetto",
      "Impianti a basso impatto ambientale: nessun rumore o emissione nociva e utilizzo di materiali riciclabili"
    ],
    "title": "Perchè affidarsi a Sun Investment Group?"
  },
  "lt": {
    "cta": "",
    "items": [
      "",
      "",
      "",
      "",
      ""
    ],
    "title": ""
  },
  "pl": {
    "cta": "Chcesz wiedzieć więcej? Skontaktuj się z nami!",
    "items": [
      "Stabilne źródło długoterminowych dochodów.",
      "Możliwość dywersyfikacji (zróżnicowania) źródła dochodów dla właścicieli gruntów.",
      "Gwarancja bezpieczeństwa – budując farmy fotowoltaiczne dbamy o spełnienie wszystkich wymogów prawnych i środowiskowych.",
      "Profesjonalne prowadzenie projektów – zarządzamy nimi zgodnie z wytycznymi Międzynarodowego Stowarzyszenia Zarządzania Projektami, zapewniamy bezpośredni kontakt z osobą prowadzącą dany projekt - Kierownikiem Projektu.",
      "Realny wpływ na zmniejszenie zanieczyszczeń, poprzez wytwarzanie energii z odnawialnych źródeł."
    ],
    "title": "Zyskaj, oddając swoją ziemię w dzierżawę Sun Investment Group"
  }
}
</i18n>
